import { createModel } from '@rematch/core';

import type { RootModel } from 'store/models';

export type TActionValue = {
  isTemplateBased?: boolean;
  /**
   * Set when a template (e.g. Weight Management) already flipped the patient's
   * monthly interaction status. Tells the comment-send flow not to prompt/flip it
   * again — the flag is already true even if the activity cache hasn't refreshed.
   */
  interactionStatusUpdated?: boolean;
  sending?: boolean;
  message?: string;
  assessments?: {
    [k: string]: Record<string, any>;
  };
};

export type TAction = Record<string, TActionValue>;
export type TState = {
  actions: TAction;
  aiCommentGenCount: number;
};

const INITIAL_STATE: TState = {
  actions: {},
  aiCommentGenCount: 0,
};

const activityActions = createModel<RootModel>()({
  state: INITIAL_STATE,
  reducers: {
    updateAction: (
      { actions, ...other },
      { idx, action }: { idx: number | string; action: TActionValue },
    ) => ({
      ...other,
      actions: {
        ...actions,
        [idx]: { ...actions[idx], ...action },
      },
    }),
    resetActions: (state) => ({ ...state, actions: {} }),
    resetCurrentActions: (state, idx: number | string) => ({
      ...state,
      actions: { ...state.actions, [idx]: {} },
    }),
    increaseAiCommentCount: ({ aiCommentGenCount, ...other }) => ({
      ...other,
      aiCommentGenCount: aiCommentGenCount + 1,
    }),
    decreaseAiCommentCount: ({ aiCommentGenCount, ...other }) => ({
      ...other,
      aiCommentGenCount: aiCommentGenCount - 1,
    }),
  },
});

export default activityActions;
